import { render, staticRenderFns } from "./MySettings.vue?vue&type=template&id=29535562&scoped=true&"
import script from "./MySettings.vue?vue&type=script&lang=ts&"
export * from "./MySettings.vue?vue&type=script&lang=ts&"
import style0 from "./MySettings.vue?vue&type=style&index=0&id=29535562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29535562",
  null
  
)

export default component.exports